import { cn } from '@bridebook/aura';
import type { ComponentType, SVGProps } from 'react';

export type SvgIcon = ComponentType<SVGProps<SVGSVGElement>>;

interface IconProps {
  /**
   * The SVG icon component to render
   */
  icon: SvgIcon;
  /**
   * The size of the icon. You can add "1lh" for the same height as the surrounding text.
   */
  size?: number | string;
  /**
   * Additional CSS classes to apply to the icon
   */
  className?: string;
}

export const Icon = ({ icon: IconComponent, size = 24, className = '', ...props }: IconProps) => (
  <IconComponent className={cn('shrink-0', className)} width={size} height={size} {...props} />
);
